<template>
  <div class="data-list-container">
    <div v-if="!systemManagementComponetView">
      <div class="my-6">
        <h4 class="mb-4 px-2">SYSTEM</h4>
        <vs-row>
          <vs-col
            vs-lg="6"
            vs-sm="12"
            class="p-2"
            :key="indextr"
            v-for="(eachData, indextr) in system_list_role"
          >
            <div
              style="cursor: pointer"
              class="light_grey_holder flex justify-between items-center p-4"
              @click="
                systemManagement(eachData.user_role_id, eachData.role_name)
              "
            >
              <div class="inline-flex items-center">
                <div class="light_blue_icon_holder">
                  <span class="material-icons-outlined">person_outline</span>
                </div>
                <p style="text-transform: capitalize" class="pl-2">
                  {{ eachData.role_name }} Role Management
                </p>
              </div>
              <span class="material-icons-outlined">navigate_next</span>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="mb-6">
        <div class="flex flex-wrap justify-between items-center mb-4 px-2">
          <h4>CUSTOM</h4>
          <vs-button @click="handleAddRole" color="primary">
            Add New Role
          </vs-button>
        </div>
        <vs-row>
          <vs-col
            vs-lg="6"
            vs-sm="12"
            class="p-2"
            :key="indextr"
            v-for="(eachData, indextr) in list_role"
          >
            <div
              style="cursor: pointer"
              class="light_grey_holder flex justify-between items-center p-4"
              @click="
                systemManagement(eachData.user_role_id, eachData.role_name)
              "
            >
              <div class="inline-flex items-center">
                <div class="light_blue_icon_holder">
                  <span class="material-icons-outlined">person_outline</span>
                </div>
                <p style="text-transform: capitalize" class="pl-2">
                  {{ eachData.role_name }}
                </p>
              </div>
              <vs-dropdown>
                <vs-button
                  class="btn-drop"
                  type="flat"
                  icon="more_vert"
                ></vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="editRole(eachData.user_role_id)">
                    Edit
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="openConfirm(eachData.user_role_id)">
                    Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </vs-col>
        </vs-row>
        <!-- <div slot="media">
        <vs-table class="cstm_vuexy_table" :data="list_role">
          <template slot="thead">
            <vs-th>Role Name</vs-th>
            <vs-th style="width: 135px;">Module Access</vs-th>
            <vs-th style="width: 100px;">User Info</vs-th>
            <vs-th style="width: 120px;">Action</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ data[indextr].role_name }}</vs-td>
              <vs-td>
                <vs-button
                  color="primary"
                  class="m-auto"
                  icon="settings"
                  :to="{
                    name: 'role-module-set-access',
                    params: { moduleId: data[indextr].user_role_id },
                  }"
                >
                </vs-button>
              </vs-td>

              <vs-td>
                <vs-button
                  color="primary"
                  class="m-auto"
                  icon="settings"
                  :to="{
                    name: 'role-user-module-access',
                    params: { moduleId: data[indextr].user_role_id },
                  }"
                >
                </vs-button>
              </vs-td>

              <vs-td>
                <div style="display: flex">
                  <vs-button
                    radius
                    color="primary"
                    icon="edit"
                    class="mr-2"
                    @click="editRole(data[indextr].user_role_id)"
                  ></vs-button>
                  <vs-button
                    radius
                    color="danger"
                    icon="delete"
                    @click="openConfirm(data[indextr].user_role_id)"
                    class="mr-2"
                  ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div> -->
      </div>
    </div>

    <!-- Add Pop Up-->
    <vs-popup title="Create a New Role" :active.sync="addstatusModal">
      <vs-row>
        <form data-vv-scope="add_role" class="w-full">
          <span>Role Name</span><span style="color: red"> *</span>
          <vs-input
            v-validate="'required'"
            v-model="role_name"
            name="role name"
            class="mt-3 w-full"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('add_role.role name')"
            >{{ errors.first("add_role.role name") }}</span
          >
        </form>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          id="save_status_id"
          type="filled"
          class="mr-2 vs-con-loading__container"
          @click="handleSaveRole"
          :disabled="role_name === ''"
          >Save</vs-button
        >
        <vs-button @click="handleCancelRolePopUp" color="primary" type="border"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <!-- Add Pop Up-->
    <!-- Edit Pop Up -->
    <vs-popup title="Edit Role" :active.sync="editRoleModal">
      <vs-row>
        <form data-vv-scope="edit_role" class="w-full">
          <span>Role Name</span>
          <vs-input
            v-validate="'required'"
            placeholder="Role Name"
            v-model="editedRole.role_name"
            name="role name"
            class="mt-3 w-full"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('edit_role.role name')"
            >{{ errors.first("edit_role.role name") }}</span
          >
          <!-- <vs-checkbox color="success" v-model="editedRole.admin_portal_access" class="mt-3">Admin Portal Access</vs-checkbox>
            <vs-checkbox color="success" v-model="editedRole.education_portal_access"  class="mt-3">Staff Portal Access</vs-checkbox> -->
          <!-- <vs-checkbox color="success" v-model="editedRole.client_portal_access" class="mt-3">Client Portal Access</vs-checkbox> -->
        </form>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          id="save_status_id"
          :disabled="editedRole.role_name === ''"
          type="filled"
          class="mr-2 vs-con-loading__container"
          @click="handleSaveEditRole(editedRole.user_role_id)"
        >
          Save</vs-button
        >
        <vs-button
          @click="handleCancelEditRolePopUp"
          color="primary"
          type="border"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <!-- edit Pop Up -->

    <systemManagementComponet
      v-if="systemManagementComponetView"
      :module_id="module_id"
      :module_name="module_name"
      @saveSystem="saveSystem"
    />
  </div>
</template>
<script>
import systemManagementComponet from '@/views/pages/roleManagement/roleModuleSelection.vue'

import {
  List_role,
  Create_role,
  Delete_Role,
  FetchEditRole,
  UpdateRoleList
} from '@/api/role'
export default {
  name: 'RoleManagement',
  components: {
    systemManagementComponet
  },
  data () {
    return {
      module_id: null,
      module_name: null,
      systemManagementComponetView: false,
      customer_id: '',
      addstatusModal: false,
      editRoleModal: false,
      editedRole: {
        user_role_id: '',
        role_name: '',
        admin_portal_access: true,
        education_portal_access: ''
        // client_portal_access : ''
      },
      role_name: '',
      admin_portal_access: true,
      education_portal_access: false,
      // client_portal_access:false,

      list_role: [],
      system_list_role: [],
      query_page: {
        page: 1,
        limit: 1000
      },
      deleted_id: ''
    }
  },
  mounted () {
    this.getCustomerId()
  },
  methods: {
    saveSystem () {
      this.systemManagementComponetView = false
    },
    systemManagement (module_id, module_name) {
      this.module_id = module_id
      this.module_name = module_name
      this.systemManagementComponetView = true
    },
    handleAddRole () {
      this.addstatusModal = true
    },
    handleCancelRolePopUp () {
      this.$validator.reset()
      this.addstatusModal = false
    },
    handleCancelEditRolePopUp () {
      this.$validator.reset()
      this.editRoleModal = false
    },
    getCustomerId () {
      const data = localStorage.getItem('customer_id')

      this.customer_id = data
      this.fetch_role_list('system')
      this.fetch_role_list('custom')
    },
    async fetch_role_list (type = 'system') {
      this.$vs.loading()
      try {
        const paramspayload = {
          type
        }

        const { data } = await List_role(
          this.query_page,
          this.customer_id,
          paramspayload
        )

        if (type === 'system') {
          this.system_list_role = data.data.role_list
        } else {
          this.list_role = data.data.role_list
        }
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
      }
    },
    handleSaveRole () {
      this.$validator.validateAll('add_role').then((valid) => {
        if (valid) {
          const payload = {
            role_name: this.role_name,
            admin_portal_access: this.admin_portal_access ? 1 : 0,
            education_portal_access: this.education_portal_access ? 1 : 0,
            customer_id: this.customer_id
            // client_portal_access:this.client_portal_access ? 1 : 0
          }

          Create_role(payload)
            .then((data) => {
              this.list_role.push(data.data.data.role)
              this.$vs.notify({
                title: 'Success',
                text: 'New Role Added Successfully',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })
              this.addstatusModal = false
              this.role_name = ''
              this.admin_portal_access = ''
              this.education_portal_access = ''
            })
            .catch((errors) => {
              this.$vs.notify({
                title: errors.data.message,
                text: errors.data.errors.role_name[0],
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })
            })
        } else {
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      })
    },
    openConfirm (id) {
      this.deleted_id = id

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete this role?',
        accept: this.acceptAlert
      })
    },
    acceptAlert () {
      this.Roles_Delete(this.deleted_id)
    },
    async Roles_Delete (id) {
      try {
        const customer_id = localStorage.getItem('customer_id')
        await Delete_Role(id, customer_id)

        const deleteIndex = this.list_role.findIndex(
          (element) => element.user_role_id === id
        )

        this.list_role.splice(deleteIndex, 1)

        this.$vs.notify({
          title: 'Success',
          text: 'Role Deleted Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
        console.log(e)
      }
    },
    editRole (id) {
      this.fetch_edit_role(id)
    },
    async fetch_edit_role (id) {
      try {
        const { data } = await FetchEditRole(id)

        this.editedRole.user_role_id = data.data.role_details.user_role_id
        this.editedRole.role_name = data.data.role_details.role_name
        this.editedRole.admin_portal_access =
          data.data.role_details.admin_portal_access
        this.editedRole.education_portal_access =
          data.data.role_details.education_portal_access

        // this.editedRole.client_portal_access = data.data.role_details.client_portal_access
        this.editRoleModal = true
      } catch (e) {
        console.log(e)
      }
    },
    handleSaveEditRole (id) {
      this.$validator.validateAll('edit_role').then((valid) => {
        if (valid) {
          const payload = {
            user_role_id: id,
            role_name: this.editedRole.role_name,
            admin_portal_access: this.editedRole.admin_portal_access ? 1 : 0,
            education_portal_access: this.editedRole.education_portal_access
              ? 1
              : 0,
            customer_id: this.customer_id

            // client_portal_access : this.editedRole.client_portal_access ? 1 : 0
          }

          this.updateEditRole(payload)
        } else {
          this.$vs.notify({
            title: 'Warning',
            text: 'Validation is required',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      })
    },
    async updateEditRole (payload) {
      try {
        await UpdateRoleList(payload)

        const index = this.list_role.findIndex(
          (element) => element.user_role_id === payload.user_role_id
        )
        //for temp
        this.list_role[index].admin_portal_access = payload.admin_portal_access
        // this.list_role[index].client_portal_access = payload.client_portal_access
        this.list_role[index].education_portal_access =
          payload.education_portal_access
        this.list_role[index].role_name = payload.role_name

        //for temp
        this.editRoleModal = false
        this.$vs.notify({
          title: 'Success',
          text: 'Role Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style>
.vs-component .vs-dropdown--item,
.vs-dropdown--item-link,
.vs-dropdown--group-label,
.vs-component .vs-dropdown--group .marginIcon {
  font-weight: 500 !important;
}
</style>
